/**
 * @file api/actionRuns.js
 * @description API functions for the /api/action-runs resource.
 */

import apiClient from './client';

/**
 * Fetches every action run triggered by a given request, with its log lines.
 *
 * @param {string} correlationId - Correlation id from the request log entry.
 * @returns {Promise<Array>}
 */
export const listActionRuns = async (correlationId) => {
  const res = await apiClient.get('/api/action-runs', {
    params: { correlation_id: correlationId },
  });
  return res.data.data;
};

/**
 * Fetches the names of all actions registered on the server.
 * @returns {Promise<Array<{ name: string, description: string }>>}
 */
export const listAvailableActions = async () => {
  const res = await apiClient.get('/api/action-runs/available');
  return res.data.data;
};
